import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BackstageAlbumGridItem from './BackstageAlbumGridItem';
import BackstageGrid from './BackstageGrid';

class BackstageAlbumGrid extends React.Component {
  static propTypes = {
    pandoraIds: ImmutablePropTypes.listOf(PropTypes.string),
    numPlaceholders: PropTypes.number,
    isDisabled: PropTypes.bool,
  };

  render() {
    let listBackstageAlbums = this.props.pandoraIds;

    if (this.props.numPlaceholders <= listBackstageAlbums.size) {
      listBackstageAlbums = listBackstageAlbums.setSize(this.props.numPlaceholders);
    }

    return (
      <BackstageGrid>
        {listBackstageAlbums.map((pandoraId, index) => {
          return (
            <BackstageAlbumGridItem
              pandoraId={pandoraId}
              key={`${index}-${pandoraId}`}
              isDisabled={this.props.isDisabled}
            />
          );
        })}
      </BackstageGrid>
    );
  }
}

export default BackstageAlbumGrid;
